import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CdTimerComponent } from 'angular-cd-timer';
import { ToasterService } from 'angular2-toaster';
import { DxTextBoxComponent, DxValidatorComponent } from 'devextreme-angular';
import { ConfigService } from 'src/app/services/config.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-social-signin-verify-otp',
  templateUrl: './social-signin-verify-otp.component.html',
  styleUrls: ['./social-signin-verify-otp.component.scss']
})
export class SocialSigninVerifyOtpComponent implements OnInit {
    phoneNum: any;
    selectedCountryCode: any;
    otpNewValue: any;
  
    @ViewChild("basicTimer", { static: true }) basicTimer: CdTimerComponent;
    @ViewChild("otpText1", { static: false }) public otpBox1: DxTextBoxComponent;
    @ViewChild("otpText2", { static: false }) public otpBox2: DxTextBoxComponent;
    @ViewChild("otpText3", { static: false }) public otpBox3: DxTextBoxComponent;
    @ViewChild("otpText4", { static: false }) public otpBox4: DxTextBoxComponent;
    @ViewChild("otpText5", { static: false }) public otpBox5: DxTextBoxComponent;
    @ViewChild("otpText6", { static: false }) public otpBox6: DxTextBoxComponent;
  
  
    otpValue1: string = null;
    otpValue2: string = null;
    otpValue3: string = null;
    otpValue4: string = null;
    otpValue5: string = null;
    otpValue6: string = null;
  
    constructor(private config: ConfigService,
      private toasterService: ToasterService, public router: Router, private loginService:LoginService) { }
  
  
    valueofOTP: boolean = true;
  
    ngOnInit() {
      this.basicTimer.start();
  
      setTimeout(() => {
        this.valueofOTP = false;
      }, 120000);
    }
  
    focusOutFunction(e) {
      if (this.otpValue1 != "") {
        this.otpBox2.instance.focus();
      }
    }
    focusOutFunction1(e) {
      if (this.otpValue2 != "") {
        this.otpBox3.instance.focus();
      }
      if (this.otpValue2 == "") {
        this.otpBox1.instance.focus();
      }
    }
    focusOutFunction2(e) {
  
      if (this.otpValue3 != "") {
        this.otpBox4.instance.focus();
      }
      if (this.otpValue3 == "") {
        this.otpBox2.instance.focus();
      }
    }
    focusOutFunction3(e) {
  
      if (this.otpValue4 != "") {
        this.otpBox5.instance.focus();
      }
      if (this.otpValue4 == "") {
        this.otpBox3.instance.focus();
      }
    }
    focusOutFunction4(e) {
  
      if (this.otpValue5 != "") {
        this.otpBox6.instance.focus();
      }
      if (this.otpValue5 == "") {
        this.otpBox4.instance.focus();
      }
    }
    focusOutFunction5(e) {
      if (this.otpValue6 == "") {
        this.otpBox5.instance.focus();
      }
    }
  
    onlyNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    }
  
  
    resendOTP() {
     
      this.valueofOTP = true;

      this.basicTimer.start();
      setTimeout(() => {
        this.valueofOTP = false;
      }, 120000);

      this.loginService.sendOTPForSignUp(this.config.userDetails["mobileNumber"], this.config.userDetails["countryCode"],this.constructor.name).subscribe(result => {
        console.log(result);
  
        if(result['message'].code == 0){         
          this.toasterService.pop("success", "OTP Sent Successfully!");
          //this.phoneNum, this.selectedCountryCode 
          // this.config.userDetails["mobileNumber"] = this.phoneNum;
          // this.config.userDetails["countryCode"] = this.selectedCountryCode;
          this.router.navigate(['social-signin-verify-otp']);
        }else if(result['message'].code == 1){
          this.toasterService.pop("error","Invalid Mobile Number!")
        }else if(result['message'].code == 1005){
          this.toasterService.pop("error","Authtoken not valid!")
        }else if(result['message'].code == 4006){ //1109
          this.toasterService.pop("error","Requested data not found!")
        }else{
          this.toasterService.pop(result['message'].message);
        }
       })
     
  
      this.clearOTP();
  
    }
  
    verifyOTPandLogin(e) {
  
      this.otpNewValue = parseInt(this.otpValue1.concat(
        this.otpValue2,
        this.otpValue3,
        this.otpValue4,
        this.otpValue5,
        this.otpValue6
      ));
      console.log("Valid data", this.otpNewValue, this.config.userDetails);
      if (this.otpNewValue.toString().length == 6) {
      
        // this.loginService.verifyOTPforSocialSignUp(this.otpNewValue, this.config.userDetails).subscribe(results => {
        //   if(results["message"].code == 200 || results["message"].code == 0  ){
        //     let redirectURL = results['data'].data.url
        //     window.location.href = redirectURL
        //   }else if(results['message'].code == 1){
        //     this.toasterService.pop("error",results["message"].message)
        //   }else if(results['message'].code == 1017){
        //     this.toasterService.pop("error",results["message"].message)
        //   }else if(results['message'].code == 4006){ //1109
        //     this.toasterService.pop("error","Requested data not found!")
        //   }else if(results['message'].code == 1117){ //1109
        //     this.toasterService.pop("error",results["message"].message)
        //   }else if(results['message'].code == 888){ //1109
        //     this.toasterService.pop("error","Account created successfully. Please login after some time!!")
        //   }else{
        //   this.toasterService.pop("error", results["message"].message)
        //   }
        // })
         this.loginService.verifyOTPforSocialSignUpV2(this.otpNewValue, this.config.userDetails , this.constructor.name).subscribe(results => {
          if(results["message"].code == 200 || results["message"].code == 0 || results["message"].code == 1018  ){
          
             this.router.navigate(['social-signin-select-mall']);
          }else{
          this.toasterService.pop("error", results["message"].message)
          }
        })
        this.clearOTP;
      } else {
        console.log("In Valid data", this.otpNewValue)
        this.toasterService.pop("error", "Invalid OTP");
        this.clearOTP();
      }
    }
  
    clearOTP(){
      this.otpValue1 = null;
      this.otpValue2 = null;
      this.otpValue3 = null;
      this.otpValue4 = null;
      this.otpValue5 = null;
      this.otpValue6 = null;
    }
  
  }
